import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Button, useTheme, Typography } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import { connect, useSelector } from 'react-redux';
import LoadingScreen from './components/common/LoadingScreen';
import Router from './router';
import { errorHandler, loadProgressBar } from './utils/axios';
import { addScrollbarStyle } from './utils/scrollbarStyle';
import { setOldToken, storeFCMToken } from './redux/slices/auth';
import { handleGettingOrderBadge } from './redux/slices/myOrder';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('Service Worker registration failed: ', registrationError);
      });
  });
}

const isFacebookBrowser = /FBAN|FBAV/.test(navigator.userAgent);

const App = ({ isReady }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const theme = useTheme();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (!isFacebookBrowser) {
      // Dynamically import Firebase modules
      import('./firebase')
        .then(({ requestNotificationPermission, messaging, onMessage, registerFBSW }) => {
          if (isLoggedIn) {
            requestNotificationPermission()
              .then((token) => {
                storeFCMToken(token);
              })
              .catch((err) => console.log('Permission denied:', err));
          }

          // Listen for Firebase messages
          onMessage(messaging, (payload) => {
            if (payload.data.type === 'Update Order') {
              handleGettingOrderBadge();
            }
            enqueueSnackbar(payload.notification.body);
          });

          // Register Firebase service worker
          registerFBSW();
        })
        .catch((error) => {
          console.error('Error importing Firebase:', error);
        });
    }
  }, [isLoggedIn]);

  // ----------------------------------------------------------------------
  useEffect(() => {
    errorHandler(enqueueSnackbar, closeSnackbar);
    return () => {};
  }, [enqueueSnackbar, closeSnackbar]);

  // ----------------------------------------------------------------------
  useEffect(() => {
    loadProgressBar();
    setOldToken();
    addScrollbarStyle(theme);
    return () => {};
  }, [theme]);

  return (
    <AnimatePresence mode="wait">
      {isReady ? (
        <RouterProvider router={Router} />
      ) : (
        <LoadingScreen
          mainLoading
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            position: 'fixed',
          }}
        />
      )}
    </AnimatePresence>
  );
};

const mapStateToProps = (state) => ({
  isReady: state.auth.isReady,
});

export default connect(mapStateToProps)(App);
